import React from "react";
import { SOURCE_CLASS_LABEL, STATUS_LABEL, TRANSMISSION_LABEL } from "./labels";

// The provenance is on the FACE of the card, never behind a disclosure. A
// reader must be able to see, without clicking anything, who says this, where
// they say it, how old it is, and whether any ancient text says it at all.
function Citation({ citation }) {
  const work = citation.work;
  return (
    <li className="correspondence-card__citation" data-source-class={citation.sourceClass}>
      <p className="correspondence-card__work">
        {work?.author ? `${work.author}, ` : ""}
        {/* The book's own page, where the Source books list has one: its tiers,
            its free editions and everything else here that cites it. */}
        {work && work.sourceBookPath ? (
          <a href={work.sourceBookPath}><cite>{work.title}</cite></a>
        ) : work ? <cite>{work.title}</cite> : null}
        {work?.written ? `, ${work.written}` : ""}
        {citation.locator ? ` — ${citation.locator}` : ""}
      </p>
      <p className="correspondence-card__citation-meta">
        {SOURCE_CLASS_LABEL[citation.sourceClass] || citation.sourceClass}
        {citation.transmissionRole
          ? ` · ${TRANSMISSION_LABEL[citation.transmissionRole] || citation.transmissionRole}`
          : ""}
        {citation.edition ? ` · ${citation.edition.name}` : ""}
        {/* Named, not hidden: a locator with no quotation is a rights fact, and
            a reader should know which of the two they are looking at. */}
        {citation.edition?.restricted ? " (in copyright: locator only)" : ""}
      </p>
      {citation.quote ? (
        <blockquote className="correspondence-card__quote">{citation.quote}</blockquote>
      ) : null}
      {citation.note ? <p className="correspondence-card__citation-note">{citation.note}</p> : null}
      {citation.url ? (
        <p><a href={citation.url} target="_blank" rel="noreferrer">Read the source</a></p>
      ) : null}
    </li>
  );
}

export default function LinkCard({ link }) {
  const sacred = link.sacredAttestation;

  return (
    <li
      className="panel correspondence-card"
      data-testid={`correspondence-${link.id}`}
      data-status={link.status}
      data-sacred={sacred || "unknown"}
    >
      <div className="panel__head correspondence-card__head">
        <h3 className="correspondence-card__title">
          {link.other.href ? <a href={link.other.href}>{link.other.name}</a> : link.other.name}
        </h3>
        <span className={`badge badge--${link.status}`}>{STATUS_LABEL[link.status] || link.status}</span>
      </div>

      <div className="panel__body">
        {/* One line, in words, instead of a four-row definition list. Every
            fact the list carried is still here: who says it, when it is first
            attested, and whether anything ancient backs it up. */}
        <p className="correspondence-card__line">
          {link.school ? link.school.name : "No school has been identified"}
          {link.school ? <span className="correspondence-card__period"> · {link.school.period}</span> : null}
          {link.earliestDisplay ? ` · oldest source ${link.earliestDisplay}` : null}
        </p>
        <p className={`correspondence-card__sacred correspondence-card__sacred--${sacred || "unknown"}`}>
          {sacred === "attested"
            ? "An ancient source says it too."
            : sacred === "none_located"
              ? "No ancient or scriptural source has been found for this correspondence."
              : "Ancient and scriptural sources have not yet been checked for this correspondence."}
        </p>
        {link.evidenceMode === "derived" ? (
          <p className="correspondence-card__mode">Put together from several passages rather than stated outright.</p>
        ) : null}

        {link.explanation ? <p className="correspondence-card__why">{link.explanation}</p> : null}

        {link.citations.length > 0 ? (
          <>
            <h4 className="correspondence-card__evidence-heading">Oldest source first</h4>
            <ol className="correspondence-card__evidence">
              {link.citations.map((citation) => (
                <Citation key={citation.id} citation={citation} />
              ))}
            </ol>
          </>
        ) : (
          <p className="correspondence-card__absent" data-testid={`no-evidence-${link.id}`}>
            No supporting source has been found, so this correspondence remains provisional.
          </p>
        )}

      </div>
    </li>
  );
}
